import React from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { get } from 'lodash';
import { useSelector } from 'react-redux';

import { translate } from 'helpers/intl';
import messages from 'containers/MRHDetailsPage/MyOffers/messages';
import MyOfferLayout from 'components/MyOffers';
import { EVENT_CATEGORIES } from 'helpers/GATracking';
import { getLocaleSelector } from 'store/LanguageProvider/selectors';
import { EPARGN_PRODUCT_LINK } from 'constants/externalLinks';

const MyOffers = (props: { intl: IntlShape }) => {
  const language = useSelector(getLocaleSelector);
  return (
    <MyOfferLayout
      category={EVENT_CATEGORIES.MRH_DETAILS}
      gaLabel="Mes contrats et garanties_En savoir plus_EPARGNE"
      title={translate(get(messages, 'title'), props)}
      subTitle={translate(get(messages, 'subTitle'), props)}
      body={translate(get(messages, 'body'), props)}
      actionPath={EPARGN_PRODUCT_LINK[language]}
      actionLabel={translate(get(messages, 'action'), props)}
      image="oldMan"
    />
  );
};

export default injectIntl(MyOffers);
